import * as React from "react";

import { Dialog as DialogPrimitive } from "radix-ui";
import { cn } from "@facade/lib/utils";

function DialogTitle({
  className,
  ...props
}: React.ComponentProps<typeof DialogPrimitive.Title>) {
  return (
    <DialogPrimitive.Title
      data-slot="dialog-title"
      className={cn("font-heading text-lg font-medium", className)}
      {...props}
    />
  );
}

export { DialogTitle };
